"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.grades.free': 'Gratis',
    'account.grades.free.description': 'Características básicas para comenzar',
    'account.grades.free.feature1': 'Uso mensual limitado',
    'account.grades.free.feature2': 'Modelos de IA básicos',
    'account.grades.free.feature3': 'Soporte de la comunidad',
    'account.grades.basic': 'Básico',
    'account.grades.basic.description': 'Características mejoradas para usuarios regulares',
    'account.grades.basic.feature1': 'Mayor uso mensual',
    'account.grades.basic.feature2': 'Modelos de IA estándar',
    'account.grades.basic.feature3': 'Soporte por correo electrónico',
    'account.grades.pro': 'Pro',
    'account.grades.pro.description': 'Características avanzadas para profesionales',
    'account.grades.pro.feature1': 'Alto uso mensual',
    'account.grades.pro.feature2': 'Modelos de IA premium',
    'account.grades.pro.feature3': 'Soporte prioritario',
    'account.grades.ultra': 'Ultra',
    'account.grades.ultra.description': 'Características máximas para usuarios avanzados',
    'account.grades.ultra.feature1': 'Uso ilimitado',
    'account.grades.ultra.feature2': 'Todos los modelos de IA',
    'account.grades.ultra.feature3': 'Soporte dedicado',
};
